"use client";
const e = Object.freeze({
  lg: "1.125rem",
  md: "1rem",
  sm: "0.875rem",
  xl: "1.25rem",
  xs: "0.75rem",
  xxl: "1.5rem",
  xxs: "0.625rem",
  xxxl: "2rem",
  xxxxl: "3rem"
}), x = Object.keys(e);
export {
  e as FONT_SIZES,
  x as FONT_SIZE_KEYS
};
